import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { pickBy } from 'lodash';
import history from 'app/main/routerHistory';
import { Autocomplete } from 'app/components/Form';
import { documentTitle } from 'app/components/DocumentTitle/DocumentTitle.jsx';
import classes from 'app/pages/Project/ProductionManagement/FollowUp/RightContent.module.scss';
import TableFollowUpRedux from 'app/pages/Project/ProductionManagement/FollowUp/TableFollowUpRedux';
import { resetReduxFilters } from 'app/store/reducers/tablesFilters';
import { resetFollowUpAssets } from 'app/store/reducers/assets';
import { setAssetId, setTrackingSchemaID } from 'app/store/reducers/tableFollowUpPrefs';
import { setStatsOpen } from 'app/store/reducers/stats';
import { setCustomTableSetting, setTableId, setTablePage } from 'app/store/reducers/tablesPrefs';
import { assetsResourcesSelector } from 'app/store/selectors/assets';
import usePinnedOptions from 'app/pages/Project/ProductionManagement/FollowUp/usePinnedOptions';
import { sortTrackingSchemasOptions } from 'app/pages/Project/ProductionManagement/FollowUp/utilsTS';
const RightContent = (props) => {
    var _a;
    const { projectId, assetId, tableId, trackingSchemaId, lockFilters, isExternal, permissions } = props;
    const dispatch = useDispatch();
    const match = useRouteMatch();
    const assets = useSelector(assetsResourcesSelector);
    const asset = (_a = Object.values(assets)) === null || _a === void 0 ? void 0 : _a.find((asset) => asset.id === assetId);
    const [pinnedOptions] = usePinnedOptions();
    const trackingSchemas = useSelector((state) => {
        const allTS = state.trackingSchemas.resources;
        return pickBy(allTS, (ts) => {
            if (ts.isVisible && ts.project === projectId) {
                if (!isExternal && !ts.isExternal)
                    return true;
                if (isExternal && ts.isExternal)
                    return true;
                return false;
            }
            return false;
        });
    });
    const currentTrackingSchema = trackingSchemaId ? trackingSchemas[trackingSchemaId] : null;
    const options = sortTrackingSchemasOptions(trackingSchemas, asset === null || asset === void 0 ? void 0 : asset.assetType, pinnedOptions);
    const selected = options.find((option) => option.value === trackingSchemaId) ? trackingSchemaId : null;
    const customTableSetting = useSelector((state) => state.tablesPrefs.customTableSetting);
    function onChangeTrackingSchema({ value }, e) {
        if (!lockFilters && !customTableSetting) {
            dispatch(resetReduxFilters());
        }
        dispatch(setStatsOpen(false));
        dispatch(setCustomTableSetting(null));
        dispatch(setTrackingSchemaID(trackingSchemaId));
        dispatch(resetFollowUpAssets());
        dispatch(setTablePage === null || setTablePage === void 0 ? void 0 : setTablePage(0));
        history.pushWithParams(match, { trackingSchemaId: value }, e.shiftKey ? '?resetTable=true' : undefined);
    }
    function toolbar(selected, options) {
        return (_jsx("div", { className: classes.toolbarContainer, children: _jsx("div", { className: classes.toolbarContainer, children: _jsx(Autocomplete, { searchable: true, selected: selected, options: options, searchResultsCurrentMaxHeight: 350, fuseConfig: { keys: ['label', 'label.props.children'] }, onChange: onChangeTrackingSchema, style: { marginRight: 5, height: 35, width: 250 }, inputStyle: { backgroundColor: '#fecd00' }, animeKeyPressed: { shift: true }, pinnable: true }) }) }));
    }
    useEffect(() => {
        var _a;
        if (trackingSchemaId) {
            let title = ((_a = trackingSchemas[trackingSchemaId]) === null || _a === void 0 ? void 0 : _a.name) || 'Follow-up';
            if (asset === null || asset === void 0 ? void 0 : asset.name)
                title = `${asset.name} - ${title}`;
            documentTitle(title, 'page');
        }
    }, [asset, trackingSchemaId]);
    useEffect(() => {
        dispatch(setTableId(tableId));
        dispatch(setTrackingSchemaID(trackingSchemaId));
        dispatch(setAssetId(asset === null || asset === void 0 ? void 0 : asset.id));
    }, [tableId, trackingSchemaId, asset === null || asset === void 0 ? void 0 : asset.id]);
    return (_jsx(TableFollowUpRedux, { asset: asset, trackingSchema: currentTrackingSchema, extendToolbar: toolbar(selected, options), projectId: projectId, permissions: permissions, lockFilters: lockFilters, tableId: tableId }));
};
export default RightContent;
